import { Component, effect, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { CustomTourService } from "../../services/custom-tour.service";
import { Subscription } from "rxjs";
import { DialogInvokingComponents } from "@models/generic-dialog.model";
import { DialogService } from "../../services/dialog/dialog.service";
import { Events } from "~/src/utils/action";

@Component({
    selector: "app-designer-tour",
    templateUrl: "./designer-tour.component.html",
    styleUrl: "./designer-tour.component.scss",
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DesignerTourComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription = new Subscription();
    private gifContainer: HTMLDivElement | null = null;
    private isGifDialogOpen = false;
    public isDirectSearchTour: boolean = true;

    constructor(
        public customTourService: CustomTourService,
        public dialogService: DialogService,
    ) {
        effect(() => {
            this.isDirectSearchTour = this.customTourService.isDirectTourSearchSignal();
        });
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.customTourService.start$.subscribe(() => {
                document.addEventListener(Events.keydown, this.handleKeyboardEvent);
            }),
        );

        this.subscriptions.add(
            this.customTourService.end$.subscribe(() => {
                document.removeEventListener(Events.keydown, this.handleKeyboardEvent);
            }),
        );

        this.subscriptions.add(
            this.customTourService.stepShow$.subscribe((res) => {
                this.attachGifClickEvents();
            }),
        );
    }

    public attachGifClickEvents() {
        setTimeout(() => {
            this.gifContainer = document.querySelector(".demo-gif-container") as HTMLDivElement;
            if (!this.gifContainer) return;
            this.gifContainer.removeEventListener(Events.click, this.openGifDialog.bind(this)); // Prevent duplicate listeners
            this.gifContainer.addEventListener(Events.click, this.openGifDialog.bind(this));
        }, 100);
    }

    private openGifDialog(event: Event): void {
        const src = (event.target as HTMLImageElement).src;

        this.isGifDialogOpen = true;
        const gifData = {
            componentName: DialogInvokingComponents.GifShow,
            image: src,
            secondBtn: "Close",
        };

        this.dialogService
            .openDialog(gifData, "75%")
            .afterClosed()
            .subscribe(() => {
                this.isGifDialogOpen = false;
            });
    }

    public tourPrev(): void {
        this.customTourService.prev();
    }

    public tourNext(): void {
        this.customTourService.next();
    }

    public tourEnd(): void {
        this.customTourService.end();

        if (this.isDirectSearchTour) {
            this.dialogService.onBoardingDialog();
        }

        this.customTourService.closeActions();
    }

    public onClick(event: Event): void {
        event.stopPropagation();
        (document.activeElement as HTMLElement).blur();
    }

    private handleKeyboardEvent = (event: KeyboardEvent): void => {
        if (this.isGifDialogOpen) return;
        if (!this.isDirectSearchTour) {
            if (event.key === Events.arrowRight) this.tourNext();
            else if (event.key === Events.arrowLeft) this.tourPrev();
        }
    };

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        window.removeEventListener(Events.keydown, this.handleKeyboardEvent);
    }
}
